import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';
import { useParams } from 'react-router-dom';
import { handleSave } from '../../MitigationTable';
import EventButton from '../../Buttons/EventButton';

function MitigationsImplementated({ srm, editItem }) {
  const { id } = useParams();

  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState(null);
  const [subCauses, setSubCauses] = useState([]);

  const [formData, setFormData] = useState({
    id: 0,
    cause_id: editItem ? editItem.id : '',
    incident_id: srm ? srm.id : 0,
    causeId: 0,
    incidentCauseId: 0,
    incidentId: srm ? srm.id : 0,
  });

  useEffect(() => {
    setLoading(true);
    axios.get('http://localhost:8080/occurrences-data/incident-sub-causes')
      .then(({ data }) => {
        setSubCauses(data);
      })
      .catch((error) => {
        setErrors(error);
      })
      .finally(() => {
        setLoading(false);
      });

    if (editItem) {
      setFormData({
        causeId: '',
        incidentCauseId: editItem ? editItem.id : 0,
        incidentId: srm ? srm.id : 0,
      });
    } else {
      setFormData({
        id: 0,
        cause_id: '',
        incident_id: srm ? srm.id : 0,
      });
    }
    console.log('loading and error', loading, errors);
  }, [editItem, srm, id]);

  const handleChange = (name, value) => {
    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleSubmit = async () => {
    console.log('formData', formData);
    const method = editItem ? 'PATCH' : 'POST';
    const url = editItem
      ? 'occurrences-data/update-incident-cause'
      : 'occurrences-data/add-incident-causes/';
    await handleSave(url, formData, method);
  };

  return (
    <div className="relative p-4 w-full max-w-2xl max-h-full">
      <div className="flex flex-wrap mx-3 w-full">
        <div className="flex flex-col w-full px-3 lg:mb-6">
          <p className="text-gray-400 text-sm mb-2">
            Cause
            <span className="text-red-500">*</span>
          </p>
          <select
            className="relative border-2 border-gray-500 bg-gray-300 px-5 rounded-md text-sm text-gray-500 text-bold leading-tight focus:outline-none focus:bg-white"
            value={editItem ? formData.causeId : formData.cause_id}
            onChange={(event) => handleChange(editItem ? 'causeId' : 'cause_id', event.target.value)}
          >
            <option
              value=""
              className="block px-4 py-2 hover:bg-gray-100 dark:hover:bg-gray-600 dark:hover:text-white"
            >
              {editItem ? editItem.main_cause_name : 'Select Cause'}
            </option>
            {subCauses.map((cause) => (
              <option
                key={cause.id}
                value={cause.id}
              >
                {cause.name}
              </option>
            ))}
          </select>
        </div>
      </div>
      <EventButton
        onSubmit={handleSubmit}
        linktext={editItem ? 'Edit' : 'Add'}
      />
    </div>
  );
}

MitigationsImplementated.propTypes = {
  editItem: PropTypes.shape({
    id: PropTypes.number,
    description: PropTypes.string,
    reportedBy: PropTypes.string,
    main_cause_name: PropTypes.string,
  }),
  // srm: PropTypes.object,
  // eslint-disable-next-line react/forbid-prop-types
  srm: PropTypes.object.isRequired,
};

MitigationsImplementated.defaultProps = {
  editItem: null,
  // srm: null,
};

export default MitigationsImplementated;
